import { MATCH_LIST_QUERY_KEY, matchQueryOptions } from "@/features/matches";
import type { RealtimeHandler } from "@/shared/realtime";

import { analysisQueryOptions } from "../api/analysisQueryOptions";
import { analysisUsageQueryOptions } from "../api/analysisUsageQueryOptions";
import type { Analysis } from "../model/Analysis";

// `analysis.failed` → статус и код ошибки сразу в кэш (экран показывает причину без запроса),
// затем перечитывание через REST; упавший разбор не тратит лимит — перечитывается и он.
// Идемпотентен.
export const handleAnalysisFailed: RealtimeHandler<"analysis.failed"> = (
  event,
  { queryClient },
) => {
  const { queryKey } = analysisQueryOptions(event.analysis_id);
  queryClient.setQueryData<Analysis>(queryKey, (old) =>
    old === undefined ? old : { ...old, status: "failed" as const, error: event.error },
  );
  void queryClient.invalidateQueries({ queryKey });
  void queryClient.invalidateQueries({ queryKey: matchQueryOptions(event.match_id).queryKey });
  void queryClient.invalidateQueries({ queryKey: MATCH_LIST_QUERY_KEY });
  void queryClient.invalidateQueries({ queryKey: analysisUsageQueryOptions().queryKey });
};
